import {
  ODSTooltip,
  type ODSTooltipPlacement,
  type ODSTooltipTriggerType,
} from '@telekom-ods/react-ui-kit';
import React from 'react';
import type { ReactNode } from 'react';

interface TooltipProps {
  children?: ReactNode;
  title?: string;
  alignment?: 'start' | 'center' | 'end';
  label?: string;
  offset?: number;
  placement?: ODSTooltipPlacement;
  trigger?: ReactNode;
  triggerEvent?: ODSTooltipTriggerType;
  className?: string;
}

const Tooltip = ({
  children,
  title = '',
  alignment = 'center',
  label,
  offset = 10,
  placement = 'top',
  trigger,
  triggerEvent = 'hover-focus',
  className = '',
}: TooltipProps): React.JSX.Element | null => {
  const tooltipLabel = label ?? (title || '');
  const tooltipTrigger = trigger ?? (children ? <div>{children}</div> : null);

  if (!tooltipLabel) {
    if (typeof tooltipTrigger === 'string') {
      return <span>{tooltipTrigger}</span>;
    }

    if (React.isValidElement(tooltipTrigger)) {
      return tooltipTrigger;
    }

    return null;
  }

  return (
    <ODSTooltip
      className={className}
      alignment={alignment}
      label={tooltipLabel}
      offset={offset}
      placement={placement}
      trigger={tooltipTrigger}
      triggerEvent={triggerEvent}
    />
  );
};

export default Tooltip;
